export enum Status {
    ONLINE,
    OFFLINE,
}
